// Supabase client + anonymous auth bootstrap.
// The publishable (anon) key is safe to ship in the client bundle —
// access is controlled by RLS policies on the database side.

import { createClient, type Session, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (client) return client;
  if (!url || !anonKey) {
    console.warn("[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set — sync disabled.");
    return null;
  }
  client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: "just-solitaire:v1:sb",
    },
  });
  return client;
}

// Ensure there's a logged-in user. Falls back to anonymous sign-in if the
// session is empty. Returns the session (or null on failure).
export async function ensureAuthenticated(): Promise<Session | null> {
  const sb = getSupabase();
  if (!sb) return null;

  const { data: existing } = await sb.auth.getSession();
  if (existing.session) return existing.session;

  const { data, error } = await sb.auth.signInAnonymously();
  if (error) {
    console.warn("[supabase] Anonymous sign-in failed:", error.message);
    return null;
  }
  return data.session;
}

export type { Session };
